import * as React from 'react';

interface ConnectionDetailsContext {
	isOnline: boolean;
}

export const context = React.createContext<ConnectionDetailsContext>({ isOnline: true });
